var babyyoda = `[
  [40.232, 2.112],
  [26.968, -0.836],
  [14.162, -0.330],
  [13.554, -3.021],
  [39.947, -2.940],
  [24.397, -1.139],
  [19.256, 0.115],
  [4.907, -0.609],
  [14.352, 0.580],
  [5.367, -0.340],
  [2.849, 2.626],
  [5.845, -0.972],
  [6.048, 2.265],
  [3.176, -1.605],
  [2.206, 1.769],
  [3.787, -0.552],
  [3.577, 2.915],
  [1.253, 1.177],
  [2.959, -1.143],
  [1.188, -2.079],
  [3.661, 2.376],
  [1.268, -1.556],
  [2.592, -1.543],
  [0.578, 1.924],
  [0.654, -1.019],
  [1.349, -0.609],
  [0.156, 0.094],
  [0.455, -1.332],
  [0.943, 1.718],
  [1.040, -2.699],
  [0.107, 3.021],
  [0.664, 1.260],
  [0.582, -2.884],
  [0.565, -1.720],
  [0.512, -0.251],
  [1.210, -0.901],
  [0.400, -2.915],
  [0.321, 1.989],
  [0.529, -1.355],
  [0.362, 2.454],
  [0.373, 2.508],
  [0.457, -1.169],
  [0.505, 1.605],
  [0.526, -1.984],
  [0.434, 0.799],
  [0.383, 3.135],
  [0.288, -0.284],
  [0.195, -2.850],
  [0.387, 0.626],
  [0.380, -2.720],
  [0.234, 0.724],
  [0.362, 1.817],
  [0.428, -1.211],
  [0.447, 2.015],
  [0.207, -0.622],
  [0.219, 1.095],
  [0.383, -2.263],
  [0.327, 1.010],
  [0.134, -1.513],
  [0.195, -0.380],
  [0.085, 1.255],
  [0.173, 0.530],
  [0.291, 2.875],
  [0.261, -0.465],
  [0.232, 2.913],
  [0.072, -2.739],
  [0.160, 1.663],
  [0.099, -1.517],
  [0.139, 2.069],
  [0.005, 3.076],
  [0.108, 0.285],
  [0.042, -2.276],
  [0.136, 1.192],
  [0.064, 2.615],
  [0.116, 2.578],
  [0.071, -0.036],
  [0.077, 0.947],
  [0.095, 1.555],
  [0.074, 2.701],
  [0.090, -0.173],
  [0.095, 1.410],
  [0.034, 2.386],
  [0.108, 0.044],
  [0.008, -2.810],
  [0.136, 1.278],
  [0.074, -1.805],
  [0.046, 1.282],
  [0.066, 2.290],
  [0.066, 0.271],
  [0.029, -1.857],
  [0.041, -2.789],
  [0.046, 1.092],
  [0.031, 1.469],
  [0.055, 2.303],
  [0.079, 0.622],
  [0.059, 2.574],
  [0.090, 1.117],
  [0.020, -2.045],
  [0.036, 2.170],
  [0.089, 2.031],
  [0.030, 0.202],
  [0.043, 2.998],
  [0.073, 1.016],
  [0.111, 1.957],
  [0.041, -1.209],
  [0.073, 1.695],
  [0.052, 0.702],
  [0.032, 1.163],
  [0.004, -2.021],
  [0.068, 1.143],
  [0.025, 2.938],
  [0.037, 2.130],
  [0.011, 1.701],
  [0.067, 0.433],
  [0.085, 2.819],
  [0.040, 0.553],
  [0.022, -2.220],
  [0.043, 1.648],
  [0.055, 1.833],
  [0.024, -2.552],
  [0.042, 1.990],
  [0.023, 1.253],
  [0.069, 2.744],
  [0.014, 1.954],
  [0.041, 1.369],
  [0.008, 1.936],
  [0.062, 2.159],
  [0.007, -0.335],
  [0.052, 1.819],
  [0.049, 1.920],
  [0.058, 1.845],
  [0.007, -0.529],
  [0.061, 1.155],
  [0.049, 2.240],
  [0.022, 0.750],
  [0.036, 2.717],
  [0.039, 1.348],
  [0.029, 2.363],
  [0.016, 0.018],
  [0.051, 1.852],
  [0.032, 2.236],
  [0.020, 2.829],
  [0.027, 2.033],
  [0.037, 1.079],
  [0.045, 2.779],
  [0.042, 2.015],
  [0.007, -1.992],
  [0.058, 2.676],
  [0.048, 1.547],
  [0.022, 2.773],
  [0.058, 1.877],
  [0.039, 1.996],
  [0.042, 2.413],
  [0.034, 2.746],
  [0.046, 1.648],
  [0.053, 1.672],
  [0.045, 2.593],
  [0.014, 1.494],
  [0.033, 1.845],
  [0.042, 1.901],
  [0.007, -3.077],
  [0.044, 2.124],
  [0.034, 0.969],
  [0.038, 2.697],
  [0.029, 1.174],
  [0.015, 3.137],
  [0.066, 2.170],
  [0.030, 0.600],
  [0.045, -2.547],
  [0.056, 1.964],
  [0.008, -0.046],
  [0.037, 2.693],
  [0.044, 2.969],
  [0.036, 1.343],
  [0.049, 2.683],
  [0.051, 1.673],
  [0.041, 2.950],
  [0.035, 2.592],
  [0.037, 1.923],
  [0.011, -1.984],
  [0.076, 2.434],
  [0.048, 0.795],
  [0.044, 2.544],
  [0.019, 2.600],
  [0.053, 1.741],
  [0.030, 1.656],
  [0.022, 1.809],
  [0.045, 2.800],
  [0.057, 2.215],
  [0.028, -0.461],
  [0.047, 2.901],
  [0.029, 2.521],
  [0.048, 1.272],
  [0.062, -2.467],
  [0.046, 1.247],
  [0.072, -2.173],
  [0.084, 2.089],
  [0.018, 2.863],
  [0.045, -2.377],
  [0.127, 2.962],
  [0.057, 0.594],
  [0.079, 3.016],
  [0.025, -3.096],
  [0.055, 2.352],
  [0.016, 0.693],
  [0.087, 2.106],
  [0.065, -2.204],
  [0.094, 2.566],
  [0.054, 1.561],
  [0.068, -3.085],
  [0.072, 3.094],
  [0.088, 1.170],
  [0.035, 2.928],
  [0.043, 1.411],
  [0.101, -2.277],
  [0.098, 1.520],
  [0.031, 0.020],
  [0.081, -2.778],
  [0.096, 2.546],
  [0.113, -0.073],
  [0.102, -2.913],
  [0.096, 1.870],
  [0.061, -2.231],
  [0.073, 2.203],
  [0.110, 2.735],
  [0.088, -2.048],
  [0.114, 2.736],
  [0.096, 0.625],
  [0.127, 3.058],
  [0.103, 2.685],
  [0.107, 0.814],
  [0.035, -2.552],
  [0.213, 2.585],
  [0.061, 0.365],
  [0.116, 2.626],
  [0.086, 2.809],
  [0.058, -2.794],
  [0.182, 1.732],
  [0.080, 0.805],
  [0.065, 0.054],
  [0.184, 1.916],
  [0.196, -0.789],
  [0.300, 1.713],
  [0.212, -1.509],
  [0.097, 2.739],
  [0.181, 2.653],
  [0.231, 1.032],
  [0.362, -2.088],
  [0.084, -0.193],
  [0.077, 2.963],
  [0.288, 0.074],
  [0.321, -3.017],
  [0.487, -0.095],
  [0.636, 2.237],
  [0.153, 0.484],
  [0.232, -1.741],
  [0.294, -2.750],
  [0.519, 1.308],
  [0.530, -2.078],
  [0.266, 1.155],
  [0.465, -0.778],
  [0.607, 0.920],
  [0.397, 3.122],
  [0.735, 0.959],
  [0.191, 1.359],
  [0.201, -2.030],
  [0.819, 1.926],
  [1.768, -0.726],
  [0.433, -1.157],
  [0.403, 2.072],
  [0.357, -1.129],
  [0.730, -1.322],
  [1.113, 1.586],
  [0.571, 0.586],
  [0.390, -1.929],
  [0.926, 1.495],
  [1.224, -0.784],
  [0.163, -1.775],
  [0.369, -0.574],
  [0.801, -2.107],
  [1.143, 1.372],
  [0.986, -1.396],
  [3.564, 3.072],
  [0.978, 0.527],
  [3.673, 0.058],
  [1.830, -1.489],
  [0.216, 2.346],
  [4.322, 1.215],
  [1.300, 1.119],
  [0.720, 1.943],
  [9.637, -0.234],
  [7.560, 0.309],
  [6.013, -0.301],
  [11.916, -0.984],
  [3.267, 1.607],
  [18.349, -0.971],
  [13.362, -2.377],
  [19.685, -2.833],
  [9.017, 0.400],
  [43.436, 1.086],
  [121.943, -0.596]
]`

var ellipse = `[
  [0.000, -1.680],
  [50.000, 1.571],
  [0.000, -0.516],
  [0.000, 1.378],
  [0.000, -2.618],
  [0.000, -2.563],
  [0.000, -0.619],
  [0.000, 2.111],
  [0.000, 0.524],
  [0.000, 3.070],
  [0.000, -0.416],
  [0.000, 0.295],
  [0.000, 1.624],
  [0.000, 0.406],
  [0.000, 2.458],
  [0.000, 2.400],
  [0.000, -1.936],
  [0.000, -1.080],
  [0.000, -2.521],
  [0.000, -1.919],
  [0.000, -3.003],
  [0.000, 2.335],
  [0.000, -0.722],
  [0.000, -0.713],
  [0.000, -0.293],
  [0.000, 0.363],
  [0.000, -0.702],
  [0.000, -1.297],
  [0.000, -1.129],
  [0.000, -1.611],
  [0.000, -1.961],
  [0.000, 1.611],
  [0.000, 0.222],
  [0.000, -1.158],
  [0.000, 2.614],
  [0.000, 2.931],
  [0.000, 1.302],
  [0.000, -1.387],
  [0.000, 0.991],
  [0.000, 1.609],
  [0.000, 0.593],
  [0.000, 0.380],
  [0.000, -0.402],
  [0.000, -0.183],
  [0.000, 2.354],
  [0.000, 2.182],
  [0.000, 1.658],
  [0.000, -2.351],
  [0.000, 0.589],
  [150.000, 1.571]
]`

var spiral = `[
  [6.688, -3.089],
  [5.574, -3.079],
  [4.779, -3.068],
  [4.183, -3.058],
  [3.719, -3.047],
  [3.348, -3.037],
  [3.045, -3.026],
  [2.793, -3.016],
  [2.579, -3.005],
  [2.396, -2.995],
  [2.237, -2.985],
  [2.099, -2.974],
  [1.976, -2.964],
  [1.868, -2.953],
  [1.771, -2.943],
  [1.683, -2.932],
  [1.604, -2.922],
  [1.533, -2.911],
  [1.467, -2.901],
  [1.407, -2.890],
  [1.352, -2.880],
  [1.302, -2.869],
  [1.255, -2.859],
  [1.211, -2.848],
  [1.170, -2.838],
  [1.133, -2.827],
  [1.097, -2.817],
  [1.064, -2.806],
  [1.033, -2.796],
  [1.004, -2.786],
  [0.977, -2.775],
  [0.951, -2.765],
  [0.926, -2.754],
  [0.903, -2.744],
  [0.881, -2.733],
  [0.861, -2.723],
  [0.841, -2.712],
  [0.822, -2.702],
  [0.804, -2.691],
  [0.787, -2.681],
  [0.771, -2.670],
  [0.755, -2.660],
  [0.741, -2.649],
  [0.727, -2.639],
  [0.713, -2.628],
  [0.700, -2.618],
  [0.688, -2.608],
  [0.676, -2.597],
  [0.664, -2.587],
  [0.653, -2.576],
  [0.643, -2.566],
  [0.632, -2.555],
  [0.623, -2.545],
  [0.613, -2.534],
  [0.604, -2.524],
  [0.595, -2.513],
  [0.587, -2.503],
  [0.579, -2.492],
  [0.571, -2.482],
  [0.563, -2.471],
  [0.556, -2.461],
  [0.549, -2.450],
  [0.542, -2.440],
  [0.536, -2.429],
  [0.529, -2.419],
  [0.523, -2.409],
  [0.517, -2.398],
  [0.511, -2.388],
  [0.506, -2.377],
  [0.500, -2.367],
  [0.495, -2.356],
  [0.490, -2.346],
  [0.485, -2.335],
  [0.480, -2.325],
  [0.475, -2.314],
  [0.471, -2.304],
  [0.467, -2.293],
  [0.462, -2.283],
  [0.458, -2.272],
  [0.454, -2.262],
  [0.450, -2.251],
  [0.447, -2.241],
  [0.443, -2.231],
  [0.439, -2.220],
  [0.436, -2.210],
  [0.433, -2.199],
  [0.429, -2.189],
  [0.426, -2.178],
  [0.423, -2.168],
  [0.420, -2.157],
  [0.417, -2.147],
  [0.415, -2.136],
  [0.412, -2.126],
  [0.409, -2.115],
  [0.407, -2.105],
  [0.404, -2.094],
  [0.402, -2.084],
  [0.399, -2.073],
  [0.397, -2.063],
  [0.395, -2.053],
  [0.393, -2.042],
  [0.391, -2.032],
  [0.389, -2.021],
  [0.387, -2.011],
  [0.385, -2.000],
  [0.383, -1.990],
  [0.381, -1.979],
  [0.380, -1.969],
  [0.378, -1.958],
  [0.376, -1.948],
  [0.375, -1.937],
  [0.373, -1.927],
  [0.372, -1.916],
  [0.371, -1.906],
  [0.369, -1.895],
  [0.368, -1.885],
  [0.367, -1.874],
  [0.366, -1.864],
  [0.364, -1.854],
  [0.363, -1.843],
  [0.362, -1.833],
  [0.361, -1.822],
  [0.360, -1.812],
  [0.359, -1.801],
  [0.359, -1.791],
  [0.358, -1.780],
  [0.357, -1.770],
  [0.356, -1.759],
  [0.356, -1.749],
  [0.355, -1.738],
  [0.354, -1.728],
  [0.354, -1.717],
  [0.353, -1.707],
  [0.353, -1.696],
  [0.352, -1.686],
  [0.352, -1.676],
  [0.352, -1.665],
  [0.351, -1.655],
  [0.351, -1.644],
  [0.351, -1.634],
  [0.350, -1.623],
  [0.350, -1.613],
  [0.350, -1.602],
  [0.350, -1.592],
  [0.350, -1.581],
  [0.350, -1.571],
  [0.350, -1.560],
  [0.350, -1.550],
  [0.350, -1.539],
  [0.350, -1.529],
  [0.350, -1.518],
  [0.351, -1.508],
  [0.351, -1.497],
  [0.351, -1.487],
  [0.352, -1.477],
  [0.352, -1.466],
  [0.352, -1.456],
  [0.353, -1.445],
  [0.353, -1.435],
  [0.354, -1.424],
  [0.354, -1.414],
  [0.355, -1.403],
  [0.356, -1.393],
  [0.356, -1.382],
  [0.357, -1.372],
  [0.358, -1.361],
  [0.359, -1.351],
  [0.359, -1.340],
  [0.360, -1.330],
  [0.361, -1.319],
  [0.362, -1.309],
  [0.363, -1.299],
  [0.364, -1.288],
  [0.366, -1.278],
  [0.367, -1.267],
  [0.368, -1.257],
  [0.369, -1.246],
  [0.371, -1.236],
  [0.372, -1.225],
  [0.373, -1.215],
  [0.375, -1.204],
  [0.376, -1.194],
  [0.378, -1.183],
  [0.380, -1.173],
  [0.381, -1.162],
  [0.383, -1.152],
  [0.385, -1.141],
  [0.387, -1.131],
  [0.389, -1.121],
  [0.391, -1.110],
  [0.393, -1.100],
  [0.395, -1.089],
  [0.397, -1.079],
  [0.399, -1.068],
  [0.402, -1.058],
  [0.404, -1.047],
  [0.407, -1.037],
  [0.409, -1.026],
  [0.412, -1.016],
  [0.415, -1.005],
  [0.417, -0.995],
  [0.420, -0.984],
  [0.423, -0.974],
  [0.426, -0.963],
  [0.429, -0.953],
  [0.433, -0.942],
  [0.436, -0.932],
  [0.439, -0.922],
  [0.443, -0.911],
  [0.447, -0.901],
  [0.450, -0.890],
  [0.454, -0.880],
  [0.458, -0.869],
  [0.462, -0.859],
  [0.467, -0.848],
  [0.471, -0.838],
  [0.475, -0.827],
  [0.480, -0.817],
  [0.485, -0.806],
  [0.490, -0.796],
  [0.495, -0.785],
  [0.500, -0.775],
  [0.506, -0.764],
  [0.511, -0.754],
  [0.517, -0.744],
  [0.523, -0.733],
  [0.529, -0.723],
  [0.536, -0.712],
  [0.542, -0.702],
  [0.549, -0.691],
  [0.556, -0.681],
  [0.563, -0.670],
  [0.571, -0.660],
  [0.579, -0.649],
  [0.587, -0.639],
  [0.595, -0.628],
  [0.604, -0.618],
  [0.613, -0.607],
  [0.623, -0.597],
  [0.632, -0.586],
  [0.643, -0.576],
  [0.653, -0.565],
  [0.664, -0.555],
  [0.676, -0.545],
  [0.688, -0.534],
  [0.700, -0.524],
  [0.713, -0.513],
  [0.727, -0.503],
  [0.741, -0.492],
  [0.755, -0.482],
  [0.771, -0.471],
  [0.787, -0.461],
  [0.804, -0.450],
  [0.822, -0.440],
  [0.841, -0.429],
  [0.861, -0.419],
  [0.881, -0.408],
  [0.903, -0.398],
  [0.926, -0.387],
  [0.951, -0.377],
  [0.977, -0.367],
  [1.004, -0.356],
  [1.033, -0.346],
  [1.064, -0.335],
  [1.097, -0.325],
  [1.133, -0.314],
  [1.170, -0.304],
  [1.211, -0.293],
  [1.255, -0.283],
  [1.302, -0.272],
  [1.352, -0.262],
  [1.407, -0.251],
  [1.467, -0.241],
  [1.533, -0.230],
  [1.604, -0.220],
  [1.683, -0.209],
  [1.771, -0.199],
  [1.868, -0.188],
  [1.976, -0.178],
  [2.099, -0.168],
  [2.237, -0.157],
  [2.396, -0.147],
  [2.579, -0.136],
  [2.793, -0.126],
  [3.045, -0.115],
  [3.348, -0.105],
  [3.719, -0.094],
  [4.183, -0.084],
  [4.779, -0.073],
  [5.574, -0.063],
  [6.688, -0.052],
  [8.358, -0.042],
  [11.143, -0.031],
  [16.712, -0.021],
  [33.423, -0.010],
  [104.650, 1.571],
  [33.423, -3.131],
  [16.712, -3.121],
  [11.143, -3.110],
  [8.358, -3.100]
]`

var pi=`[
  [28.880, -1.254],
  [81.432, -2.570],
  [63.104, -0.969],
  [39.144, -0.313],
  [53.065, -1.355],
  [65.947, 1.196],
  [24.484, 0.533],
  [26.094, -1.110],
  [27.303, -0.646],
  [12.501, 1.903],
  [12.351, 0.054],
  [10.280, 2.555],
  [10.624, 2.264],
  [5.452, -0.810],
  [6.957, 0.600],
  [4.434, -1.728],
  [3.454, -0.989],
  [1.140, -1.432],
  [8.742, -1.239],
  [2.165, 1.535],
  [2.797, 0.655],
  [2.737, 1.560],
  [4.153, 1.719],
  [1.243, -2.763],
  [2.904, -0.115],
  [3.238, -0.378],
  [1.931, -2.513],
  [0.887, 0.429],
  [2.443, -2.013],
  [1.821, 0.693],
  [0.442, -2.197],
  [0.909, 0.532],
  [0.512, 1.101],
  [0.326, 0.370],
  [0.892, -2.395],
  [1.536, -0.118],
  [0.700, 2.123],
  [1.126, 0.794],
  [1.643, -2.381],
  [0.743, -0.537],
  [0.262, -1.405],
  [0.941, -0.243],
  [0.499, 0.120],
  [0.673, 1.138],
  [0.600, 1.696],
  [0.294, 0.296],
  [0.614, -2.160],
  [0.489, 0.291],
  [0.396, -2.214],
  [0.531, -1.334],
  [0.254, -0.511],
  [0.199, -0.245],
  [0.409, 0.234],
  [0.091, 0.944],
  [0.408, 3.121],
  [0.478, 0.781],
  [0.255, 2.147],
  [0.596, 0.431],
  [0.110, -0.539],
  [0.651, -1.514],
  [0.438, -2.072],
  [0.306, -0.464],
  [0.150, -0.351],
  [0.379, 0.616],
  [0.457, 1.744],
  [0.510, 0.112],
  [0.233, -2.139],
  [0.203, -0.635],
  [0.261, 2.815],
  [0.295, -1.513],
  [0.076, -0.320],
  [0.169, 1.233],
  [0.105, -2.796],
  [0.312, -0.021],
  [0.066, -1.505],
  [0.064, 0.054],
  [0.173, -0.383],
  [0.099, -0.791],
  [0.133, 0.413],
  [0.180, 1.577],
  [0.154, -0.709],
  [0.119, 0.186],
  [0.194, -1.051],
  [0.128, -1.539],
  [0.211, -1.581],
  [0.240, 0.856],
  [0.196, 0.342],
  [0.078, 2.923],
  [0.021, -1.247],
  [0.196, 1.690],
  [0.081, -1.752],
  [0.041, -1.359],
  [0.115, -2.035],
  [0.174, -0.964],
  [0.103, -1.260],
  [0.216, 0.141],
  [0.206, 0.496],
  [0.130, 0.345],
  [0.091, -0.138],
  [0.096, -0.858],
  [0.071, -2.681],
  [0.114, -0.050],
  [0.040, 2.659],
  [0.136, -0.335],
  [0.045, -1.459],
  [0.065, 3.083],
  [0.034, -0.650],
  [0.088, -1.481],
  [0.026, 1.757],
  [0.174, 0.933],
  [0.011, -0.621],
  [0.123, -0.555],
  [0.030, -2.135],
  [0.083, 0.732],
  [0.148, -0.848],
  [0.157, -0.507],
  [0.144, -0.502],
  [0.063, 0.223],
  [0.103, -1.346],
  [0.127, 0.168],
  [0.109, 1.497],
  [0.043, 0.462],
  [0.098, 2.799],
  [0.027, 0.731],
  [0.034, 0.932],
  [0.056, -2.073],
  [0.056, -2.118],
  [0.142, -0.926],
  [0.033, -1.957],
  [0.127, -1.042],
  [0.182, 0.752],
  [0.183, -0.295],
  [0.082, 0.781],
  [0.046, -0.446],
  [0.109, 0.578],
  [0.133, -1.078],
  [0.052, 0.356],
  [0.069, -1.252],
  [0.064, 1.517],
  [0.115, -1.308],
  [0.049, 1.352],
  [0.017, -0.897],
  [0.088, 1.350],
  [0.029, 1.530],
  [0.011, -0.311],
  [0.080, -1.329],
  [0.034, -0.685],
  [0.084, -0.682],
  [0.067, -0.605],
  [0.163, -0.736],
  [0.111, 0.361],
  [0.082, -0.238],
  [0.036, -0.270],
  [0.097, 0.153],
  [0.158, 0.840],
  [0.095, 0.340],
  [0.028, -1.061],
  [0.042, -1.603],
  [0.090, 1.673],
  [0.155, -2.172],
  [0.040, -2.165],
  [0.096, -1.487],
  [0.061, 0.694],
  [0.047, -2.160],
  [0.113, 0.155],
  [0.126, -0.249],
  [0.185, 0.554],
  [0.038, -0.730],
  [0.201, 0.294],
  [0.149, -1.438],
  [0.020, -0.581],
  [0.015, -1.043],
  [0.124, 0.156],
  [0.034, -1.310],
  [0.076, 0.900],
  [0.067, 0.665],
  [0.057, 0.888],
  [0.051, -2.317],
  [0.053, 0.917],
  [0.097, -1.393],
  [0.109, -1.630],
  [0.111, -1.587],
  [0.092, 1.975],
  [0.160, 0.160],
  [0.078, -0.046],
  [0.151, 0.221],
  [0.129, 0.111],
  [0.175, -0.346],
  [0.181, 0.590],
  [0.140, -0.644],
  [0.054, 2.254],
  [0.045, -1.596],
  [0.085, 2.250],
  [0.057, 2.961],
  [0.098, -1.808],
  [0.098, -0.862],
  [0.170, 0.661],
  [0.127, -2.243],
  [0.094, 0.280],
  [0.129, -0.053],
  [0.200, 0.394],
  [0.131, -0.534],
  [0.108, -0.601],
  [0.031, -0.122],
  [0.071, 2.256],
  [0.132, -2.959],
  [0.275, 0.194],
  [0.181, -0.030],
  [0.225, 0.643],
  [0.193, -0.599],
  [0.055, -0.690],
  [0.053, -1.273],
  [0.141, 2.620],
  [0.151, -0.987],
  [0.178, -3.010],
  [0.211, -3.009],
  [0.298, 0.721],
  [0.336, -0.378],
  [0.214, 0.570],
  [0.217, -0.547],
  [0.135, 0.774],
  [0.190, -0.704],
  [0.018, 2.718],
  [0.135, 0.769],
  [0.207, 0.578],
  [0.241, -1.780],
  [0.197, 0.268],
  [0.139, 2.163],
  [0.169, 0.021],
  [0.086, -2.105],
  [0.112, 0.212],
  [0.198, -0.063],
  [0.362, -0.814],
  [0.163, 1.774],
  [0.494, -0.125],
  [0.477, 2.736],
  [0.017, 1.581],
  [0.233, 2.308],
  [0.151, -0.060],
  [0.090, 0.236],
  [0.727, -0.705],
  [0.863, 0.015],
  [0.472, 0.041],
  [0.517, 2.798],
  [0.282, -0.044],
  [0.561, 2.361],
  [0.256, -1.174],
  [0.351, -2.177],
  [0.124, 1.981],
  [0.499, 0.742],
  [0.343, 0.704],
  [0.584, -0.267],
  [0.812, -0.544],
  [0.341, 2.663],
  [0.944, -0.738],
  [0.359, -2.999],
  [0.374, 2.076],
  [0.702, 1.748],
  [0.184, 0.361],
  [0.648, 0.421],
  [0.662, -0.203],
  [0.639, 0.525],
  [2.157, -1.035],
  [1.226, 2.594],
  [0.360, -0.084],
  [1.663, 0.929],
  [1.362, -1.415],
  [0.372, 2.171],
  [0.466, 2.225],
  [1.040, 1.079],
  [0.763, -0.714],
  [1.381, 2.120],
  [2.938, -0.937],
  [0.576, 2.017],
  [2.311, -1.266],
  [3.034, 0.284],
  [2.282, 0.220],
  [0.932, -1.546],
  [4.167, 2.380],
  [2.389, 1.755],
  [3.330, 1.079],
  [1.853, 2.995],
  [9.432, -0.687],
  [1.834, -1.426],
  [4.160, -0.435],
  [4.694, -1.447],
  [5.116, 1.104],
  [6.371, -0.305],
  [10.360, 2.588],
  [9.474, 2.877],
  [11.845, 0.367],
  [11.235, 2.231],
  [30.706, -0.387],
  [29.288, -0.990],
  [24.838, 0.625],
  [65.090, 1.353],
  [57.165, -1.229],
  [39.863, -0.255],
  [65.697, -0.947],
  [86.684, -2.562]
]`

var batman=`[
  [37.963, -1.574],
  [129.349, -1.569],
  [26.135, 1.575],
  [14.768, 1.578],
  [2.173, 1.581],
  [3.966, -1.561],
  [0.796, -1.560],
  [0.784, -1.559],
  [0.261, 1.607],
  [3.017, -1.551],
  [0.400, -1.557],
  [0.367, 1.609],
  [0.766, 1.599],
  [0.836, -1.546],
  [0.558, 1.610],
  [0.107, -1.551],
  [0.390, 1.616],
  [0.047, -1.624],
  [0.214, 1.618],
  [0.107, 1.660],
  [1.054, 1.619],
  [0.313, 1.624],
  [0.518, 1.629],
  [0.468, 1.631],
  [0.537, 1.627],
  [0.061, 1.710],
  [0.228, 1.643],
  [0.240, -1.522],
  [0.081, 1.698],
  [0.070, -1.555],
  [0.162, -1.519],
  [0.284, -1.524],
  [0.041, 1.701],
  [0.260, -1.508],
  [0.116, -1.537],
  [0.234, -1.505],
  [0.139, -1.509],
  [0.139, -1.527],
  [0.033, -1.531],
  [0.274, -1.499],
  [0.033, -1.624],
  [0.098, -1.496],
  [0.106, -1.501],
  [0.162, -1.506],
  [0.050, -1.490],
  [0.137, -1.500],
  [0.035, 1.779],
  [0.096, -1.490],
  [0.044, -1.564],
  [0.012, -1.854],
  [0.021, 1.692],
  [0.129, -1.494],
  [0.022, -1.583],
  [0.106, -1.464],
  [0.047, -1.519],
  [0.076, -1.494],
  [0.067, -1.467],
  [0.097, -1.506],
  [0.031, 1.762],
  [0.084, -1.467],
  [0.048, -1.537],
  [0.049, -1.496],
  [0.020, -1.459],
  [0.058, -1.520],
  [0.003, 2.264],
  [0.071, -1.483],
  [0.023, 1.927],
  [0.004, 2.445],
  [0.015, -1.628],
  [0.038, -1.609],
  [0.030, 1.763],
  [0.041, -1.516],
  [0.009, 2.327],
  [0.031, -1.532],
  [0.008, -2.008],
  [0.007, -2.992],
  [0.019, 1.829],
  [0.057, -1.525],
  [0.010, 2.215],
  [0.025, -1.472],
  [0.027, -1.522],
  [0.045, -1.515],
  [0.021, -1.439],
  [0.047, -1.521],
  [0.014, 1.983],
  [0.041, -1.480],
  [0.021, -1.670],
  [0.009, -1.884],
  [0.002, 1.665],
  [0.043, -1.524],
  [0.003, 2.390],
  [0.030, -1.459],
  [0.007, 2.330],
  [0.006, -2.075],
  [0.007, -1.813],
  [0.018, -1.848],
  [0.033, 1.801],
  [0.021, -1.549],
  [0.005, -2.707],
  [0.008, -1.755],
  [0.005, 2.065],
  [0.010, -2.081],
  [0.015, 1.881],
  [0.025, -1.630],
  [0.023, 1.997],
  [0.007, 2.137],
  [0.005, -2.126],
  [0.014, -1.884],
  [0.018, 1.746],
  [0.014, -1.708],
  [0.017, 2.042],
  [0.009, -1.954],
  [0.011, 2.455],
  [0.017, 2.251],
  [0.023, 1.897],
  [0.018, -1.962],
  [0.026, 1.977],
  [0.007, 2.295],
  [0.012, 2.247],
  [0.008, 3.075],
  [0.012, 2.109],
  [0.011, -2.708],
  [0.031, 1.949],
  [0.012, -2.070],
  [0.010, 2.954],
  [0.010, 2.387],
  [0.012, 1.890],
  [0.016, -1.922],
  [0.013, 1.960],
  [0.013, -1.755],
  [0.014, 2.158],
  [0.005, 2.870],
  [0.005, -2.389],
  [0.011, -2.219],
  [0.024, 1.717],
  [0.013, -1.640],
  [0.007, 2.412],
  [0.002, -2.347],
  [0.008, 2.034],
  [0.007, 3.112],
  [0.014, 1.889],
  [0.017, -1.897],
  [0.022, 1.965],
  [0.008, 1.921],
  [0.004, 2.651],
  [0.006, -2.592],
  [0.018, 1.631],
  [0.008, -2.108],
  [0.017, 1.940],
  [0.010, -1.927],
  [0.007, 2.898],
  [0.010, 2.331],
  [0.012, 1.727],
  [0.018, -1.848],
  [0.018, 1.763],
  [0.000, 2.689],
  [0.009, 2.110],
  [0.005, -2.786],
  [0.005, 2.330],
  [0.012, -2.349],
  [0.023, 1.804],
  [0.015, -1.847],
  [0.007, 3.091],
  [0.007, 2.204],
  [0.010, 1.802],
  [0.015, -2.108],
  [0.011, 1.993],
  [0.018, -1.919],
  [0.013, 2.313],
  [0.006, -2.668],
  [0.009, -2.135],
  [0.012, -2.205],
  [0.024, 1.553],
  [0.014, -1.716],
  [0.007, 2.099],
  [0.006, -1.735],
  [0.003, 2.684],
  [0.007, -2.464],
  [0.007, 1.628],
  [0.025, -1.760],
  [0.021, 1.634],
  [0.007, 1.170],
  [0.004, 1.451],
  [0.001, 2.889],
  [0.021, 1.389],
  [0.009, -1.934],
  [0.020, 1.636],
  [0.015, -1.716],
  [0.005, 2.861],
  [0.011, 1.755],
  [0.017, 1.440],
  [0.019, -1.836],
  [0.026, 1.536],
  [0.002, -1.697],
  [0.010, 1.918],
  [0.006, -2.243],
  [0.003, -2.473],
  [0.014, -2.116],
  [0.033, 1.529],
  [0.018, -1.719],
  [0.008, 1.945],
  [0.012, 1.533],
  [0.013, 1.541],
  [0.019, -1.965],
  [0.009, 1.796],
  [0.036, -1.808],
  [0.013, 2.019],
  [0.008, -2.040],
  [0.014, -1.945],
  [0.012, -2.146],
  [0.036, 1.485],
  [0.026, -1.821],
  [0.007, 2.381],
  [0.028, -1.815],
  [0.019, -2.049],
  [0.024, -2.011],
  [0.009, -2.106],
  [0.060, -1.792],
  [0.027, 1.647],
  [0.005, -1.916],
  [0.008, -2.224],
  [0.016, -1.938],
  [0.012, 1.591],
  [0.034, -1.846],
  [0.027, 1.599],
  [0.041, -1.731],
  [0.007, 2.253],
  [0.031, 1.525],
  [0.037, 1.452],
  [0.027, -1.830],
  [0.055, 1.492],
  [0.016, -1.796],
  [0.020, 1.728],
  [0.012, -1.949],
  [0.008, -2.093],
  [0.009, -2.407],
  [0.097, 1.477],
  [0.021, -1.779],
  [0.046, 1.567],
  [0.034, 1.524],
  [0.026, 1.602],
  [0.041, -1.842],
  [0.008, 1.977],
  [0.100, -1.733],
  [0.048, 1.606],
  [0.005, -2.257],
  [0.012, -2.033],
  [0.010, 2.032],
  [0.112, 1.485],
  [0.057, -1.749],
  [0.038, 1.619],
  [0.081, -1.706],
  [0.031, -1.870],
  [0.017, -2.009],
  [0.010, 1.766],
  [0.140, -1.703],
  [0.127, 1.520],
  [0.026, -1.750],
  [0.036, -1.822],
  [0.094, -1.709],
  [0.046, -1.730],
  [0.166, -1.692],
  [0.088, 1.544],
  [0.196, -1.664],
  [0.036, 1.666],
  [0.134, 1.522],
  [0.105, 1.522],
  [0.174, -1.674],
  [0.120, 1.531],
  [0.268, -1.650],
  [0.011, 2.109],
  [0.128, -1.655],
  [0.060, -1.686],
  [0.136, 1.551],
  [0.830, 1.516],
  [0.159, 1.531],
  [0.699, 1.525],
  [0.540, 1.524],
  [0.489, 1.530],
  [0.147, 1.560],
  [0.447, 1.532],
  [0.462, -1.623],
  [1.368, 1.535],
  [0.968, 1.535],
  [0.983, 1.540],
  [1.485, 1.541],
  [2.861, 1.540],
  [0.235, 1.561],
  [1.940, 1.546],
  [1.797, -1.597],
  [1.481, -1.597],
  [0.314, -1.605],
  [1.046, -1.591],
  [11.411, -1.587],
  [7.634, 1.558],
  [0.085, 1.586],
  [6.484, -1.581],
  [8.881, -1.578],
  [8.937, 1.567],
  [73.367, 1.569]
]`

export default {
  babyyoda,
  ellipse,
  spiral,
  pi,
  batman
}